<template>
<!-- 手机行业解决方案 -->
    <section class="solution phone-solution">
        <div class="layout-banner">
            <div class="banner_box"></div>
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">手机行业解决方案</div>
                    <div class="sm-text">MOBILE PHONE INDUSTRY SOLUTIONS</div>
                </div>
            </div>
            <Nav :activeIndex='"2-1"'></Nav>
        </div>
        <div class="solution-content">
            <p class="applications-title">手机行业解决方案</p>
            <p class="subhead">MOBILE PHONE INDUSTRY SOLUTIONS</p>
            <div class="solution-context">
                <div class="w-1200">
                    <div class="title">行业痛点</div>
                    <div class="desc">近几年智能手机的普及率和更新率水涨船高，与智能手机硬件高速创新、科技迭代的发展状态不同，与之相反的是手机保险产品的供给侧却陷入了“商家不敢卖、客户不敢买、保险公司不敢承保”的一个怪圈，市场上手机保险产品存在着包括产品创新不足、定价不合理、客户筛选缺失、风控手段不足、服务条款不清晰等诸多问题。
                    </div>
                </div>
            </div>
            <div class="solution-scene">
                <div class="w-1200">
                    <div class="title">主流场景</div>
                    <div class="desc">
                       <ul class="clearfix">
                            <div class="tabs-bar" :style="`transform: translate3d(${tabsBarleft}px, 0px, 0px);`"></div>
                            <li :style="`left:${index*122}px`" v-for="(item, index) in allSceneList" :key="index" :class="[index===activeScene?'active':'']" @click="sceneClick(index)">{{item.name}}</li>
                        </ul>
                        <div class="scene-row">
                            <div class="scene-col">
                                <img src="../../assets/solution/jjfa_10.jpg" alt="">
                                <div class="scene-right">
                                    <h6>方案概要</h6>
                                    <div class="text">{{allSceneList[activeScene].outline}}</div>
                                </div>
                            </div>
                            <div class="scene-col">
                                <img src="../../assets/solution/jjfa_11.jpg" alt="">
                                <div class="scene-right">
                                    <h6>核心能力</h6>
                                    <div class="text">{{allSceneList[activeScene].ability}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img :src="require(`../../assets/solution/icon${item}.png`)" alt="" v-for="item in 8" :key="item" :class="`icon${item}`">
            </div>
            <div class="solution-feature">
                <div class="w-1200">
                    <div class="title">能力模组</div>
                    <div class="desc">
                        <div class="left-top">
                            <div class="sub-title">智慧零售系统：</div>
                            <div>快速接入，轻松销售，全程风控</div>
                        </div>
                        <div class="left-bottom">
                            <div class="sub-title">智慧经营平台：</div>
                            <div>挖掘并展示手机保险底层经营数据</div>
                        </div>
                        <div class="right-top">
                            <div class="sub-title">智能理赔系统：</div>
                            <div>适配各大闭环场景，一键完成理赔审核</div>
                        </div>
                        <div class="right-bottom">
                            <div class="sub-title">智能风控组件：</div>
                            <div>多功能、多形态、低感知，各场景植入</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="solution-customer">
                <div class="w-1200">
                    <div class="title">合作客户</div>
                    <div class="desc">
                        <div class="customer" v-for="item in 9" :key="item"><img :src="require(`../../assets/partners/phone/partners${item}.jpg`)" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners15.jpg" alt=""></div>
                        <div class="itemempty"></div>
                        <div class="itemempty"></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  },
  data () {
    return {
      tabsBarleft: 0,
      activeScene: 0,
      allSceneList: [{ name: '零售门店', outline: '前端赋能一整套移动端销售工具，打通客户端、销售端、运营端、承保端，一键销售、全程风控、轻松服务', ability: '一整套手机保险产品智慧零售解决方案，合作伙伴“零”开发，支持T+0上线' },
        { name: '运营商', outline: '结合运营商各专业子公司业务场景及模式，快速输出并落地标准化增值服务产品的能力，兼顾风险管理、销售激励', ability: '多套运营商业务细分场景系统应用方案，精准适配底层场景，精准获客、快速出单' },
        { name: '金融分期', outline: '向金融场景的合作渠道输出一整套标准自助、高效高质的手机保险产品的服务能力', ability: '前端精准定义产品、客户，后端高质输出服务申请、服务交付、风控管理、经营监控在内的产品运维能力' },
        { name: '品牌厂商', outline: '基于手机保险产品的管理经验，向厂家增值业务输出一整套成熟的数据监控、门店管理、快速理赔的第三方管理能力', ability: '通过智慧经营平台、智能理赔系统结合厂家的产品及渠道特点，定向输出风险管理能力' }]
    }
  },
  methods: {
    sceneClick (index) {
      this.activeScene = index
      this.tabsBarleft = index * 122
    }
  }
}

</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.phone-solution{
    .banner_box{
        background-image: url(../../assets/banner2.png);
    }
    .solution-content{
        .solution-context{
            padding: 40px 0 60px 0;
            .desc{
                width: 100%;
                padding:25px ;
                box-shadow:0px 2px 18px rgba(3, 123, 255, 0.1);
                margin-top: 30px;
                font-size: 14px;
                color: #666;
                line-height: 2;
                cursor: pointer;
                box-shadow: 0px 2px 18px rgba(3, 123, 255, 0.1);
                transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                &:hover{
                    transform: translateY(-3px);
                    box-shadow: 0px 2px 18px rgba(3, 123, 255, 0.15);
                    transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                }
            }
        }
        .solution-feature{
            background-color:#f5faff;
            padding-top: 40px;
            .desc{
                background-image: url(../../assets/solution/solution1.png);
                background-repeat: no-repeat;
                background-position: 50% 50%;
                height: 550px;
                width: 100%;
                position: relative;
                font-size: 14px;
                color: #666666;
                &>div{
                    position: absolute;
                    height: 71px;
                    width: 263px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding: 10px 0;
                    .sub-title {
                        font-weight: 500;
                        // font-family: PingFangSC-Medium;
                        color: #333;
                    }
                }
                .left-top{
                    left: 52px;
                    top: 133px;
                }
                .left-bottom{
                    left: 52px;
                    top: 310px;
                }
                .right-top{
                    right: 52px;
                    top: 133px;
                }
                .right-bottom{
                    right: 52px;
                    top: 310px;
                }
            }
        }
    }
}
</style>
